import React from 'react'
import style from "../Home.module.css";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import Util from "../../../utils/utils";
import PermissionUtils from "../../../utils/permissionUtils";
import WorkOrderInfo from "./WorkOrderInfo";

class WorkOrderManage extends React.Component {
    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (Util.isEmpty(userName)) {
            this.props.history.push("/login")
        } else {
            let userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
            if (userRole === 0) {
                PermissionUtils.getUserPermission(this, '100012');
            }
        }
    }

    render() {
        return (
            <div className={style['home']}>
                <Header history={this.props.history}/>
                <LeftMenu history={this.props.history}/>
                <WorkOrderInfo history={this.props.history}/>
            </div>
        )
    }
}

export default WorkOrderManage;